import React from 'react';

import { ImageContainer } from './styles';

const Image = ({ src, ...rest }) => {
  return <ImageContainer src={src} {...rest} />;
};

export default Image;
